import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UrlService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root',
})
export class SaveUrlParamsGuard {
  constructor(
    private urlService: UrlService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.urlService.setParamsInStorage({
      ...route.queryParams,
      ...route.params,
    });
    this.urlService.setLastRoutedUrl(
      this.router?.getCurrentNavigation()?.initialUrl.toString()
    );
    return true;
  }
}
